import { TFunction } from 'react-i18next'

export const getWinLikelihoodDisplayText = (score: any, t: TFunction<'strH2H', undefined>) => {
  if (typeof score !== 'number') return ''

  if (score > 90)
    return t('winLikelihood.score.over', {
      score: 90,
    })
  if (score < 10)
    return t('winLikelihood.score.under', {
      score: 10,
    })

  return t('winLikelihood.score.exact', {
    ns: 'strH2H',
    score: score,
  })
}
